import { render } from "./AttivitaExtra.vue?vue&type=template&id=ed1ca0f8&scoped=true"
import script from "./AttivitaExtra.vue?vue&type=script&lang=js"
export * from "./AttivitaExtra.vue?vue&type=script&lang=js"

import "./AttivitaExtra.vue?vue&type=style&index=0&id=ed1ca0f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1ca0f8"]])

export default __exports__